import { render, staticRenderFns } from "./ButtonModeStakePage.vue?vue&type=template&id=6e86a39a&scoped=true&lang=pug"
import script from "./ButtonModeStakePage.vue?vue&type=script&lang=js"
export * from "./ButtonModeStakePage.vue?vue&type=script&lang=js"
import style0 from "./ButtonModeStakePage.vue?vue&type=style&index=0&id=6e86a39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e86a39a",
  null
  
)

export default component.exports